import { z } from "zod";
export const PLATFORM_SERVICE_COMPONENTS = [
    "portal",
    "api",
    "content_delivery",
];
export const PLATFORM_STATUS_EVENT_KINDS = [
    "incident",
    "maintenance",
];
export const PLATFORM_STATUS_EVENT_STATUSES = [
    "scheduled",
    "investigating",
    "identified",
    "monitoring",
    "in_progress",
    "resolved",
    "cancelled",
];
export const AVAILABILITY_REVIEW_DECISIONS = ["approved", "rejected"];
export const PLATFORM_COMPONENT_STATUSES = [
    "operational",
    "maintenance",
    "degraded",
    "major_outage",
];
const availabilityDateTimeSchema = z.iso.datetime({ offset: true });
const nonnegativeIntegerSchema = z.number().int().nonnegative();
const platformServiceComponentSchema = z.enum(PLATFORM_SERVICE_COMPONENTS);
const platformStatusEventStatusSchema = z.enum(PLATFORM_STATUS_EVENT_STATUSES);
export const platformStatusEventUpdateSchema = z
    .object({
    endedAt: availabilityDateTimeSchema.nullable(),
    occurredAt: availabilityDateTimeSchema,
    sequence: z.number().int().positive(),
    status: platformStatusEventStatusSchema,
    summary: z.string(),
})
    .strict();
export const platformStatusEventSchema = z
    .object({
    affectedComponents: z.array(platformServiceComponentSchema),
    announcedAt: availabilityDateTimeSchema,
    createdAt: availabilityDateTimeSchema,
    current: platformStatusEventUpdateSchema,
    id: z.string().uuid(),
    kind: z.enum(PLATFORM_STATUS_EVENT_KINDS),
    maintenanceExclusionEligible: z.boolean(),
    scheduledEndAt: availabilityDateTimeSchema.nullable(),
    startedAt: availabilityDateTimeSchema,
    title: z.string(),
    updates: z.array(platformStatusEventUpdateSchema),
})
    .strict();
const availabilityIntervalSchema = z
    .object({
    endedAt: availabilityDateTimeSchema,
    startedAt: availabilityDateTimeSchema,
})
    .strict();
const availabilityOutageIntervalSchema = availabilityIntervalSchema.extend({
    incidentIds: z.array(z.string().uuid()),
    locations: z.array(z.string()),
});
const availabilityMaintenanceIntervalSchema = availabilityIntervalSchema.extend({
    eventId: z.string().uuid(),
});
const availabilityReportFields = {
    availabilityBasisPoints: z.number().int().min(0).max(10_000).nullable(),
    component: platformServiceComponentSchema,
    evidenceComplete: z.boolean(),
    evidenceId: z.string().uuid(),
    generatedAt: availabilityDateTimeSchema,
    healthyMinutes: nonnegativeIntegerSchema,
    maintenanceExcludedMinutes: nonnegativeIntegerSchema,
    maintenanceIntervals: z.array(availabilityMaintenanceIntervalSchema),
    outageIntervals: z.array(availabilityOutageIntervalSchema),
    outageMinutes: nonnegativeIntegerSchema,
    periodEnd: availabilityDateTimeSchema,
    periodStart: availabilityDateTimeSchema,
    rawFailedChecks: nonnegativeIntegerSchema,
    rawMissingChecks: nonnegativeIntegerSchema,
    rawPassedChecks: nonnegativeIntegerSchema,
    sourceObservedAt: availabilityDateTimeSchema,
    totalMinutes: nonnegativeIntegerSchema,
    unknownMinutes: nonnegativeIntegerSchema,
};
export const platformAvailabilityReportSchema = z
    .object({
    ...availabilityReportFields,
    reviewedAt: availabilityDateTimeSchema,
})
    .strict();
export const tenantAvailabilityWorkspaceSchema = z
    .object({
    generatedAt: availabilityDateTimeSchema,
    reports: z.array(platformAvailabilityReportSchema),
    serviceEvents: z.array(platformStatusEventSchema),
    targetBasisPoints: z.number().int().min(0).max(10_000),
})
    .strict();
export const platformAvailabilityEvidenceSchema = z
    .object({
    ...availabilityReportFields,
    generationSequence: z.number().int().positive(),
    review: z
        .object({
        decision: z.enum(AVAILABILITY_REVIEW_DECISIONS),
        reviewedAt: availabilityDateTimeSchema,
        reviewedByIdentityId: z.string().uuid(),
    })
        .strict()
        .nullable(),
    sourceCheckId: z.string().min(1),
    sourceSha256: z.string().regex(/^[a-f0-9]{64}$/u),
})
    .strict();
export const platformAvailabilityWorkspaceSchema = z
    .object({
    evidence: z.array(platformAvailabilityEvidenceSchema),
    generatedAt: availabilityDateTimeSchema,
    serviceEvents: z.array(platformStatusEventSchema),
    targetBasisPoints: z.number().int().min(0).max(10_000),
})
    .strict();
export const publicPlatformStatusSchema = z
    .object({
    components: z.array(z
        .object({
        component: platformServiceComponentSchema,
        status: z.enum(PLATFORM_COMPONENT_STATUSES),
    })
        .strict()),
    generatedAt: availabilityDateTimeSchema,
    overallStatus: z.enum(PLATFORM_COMPONENT_STATUSES),
    serviceEvents: z.array(platformStatusEventSchema),
})
    .strict();
//# sourceMappingURL=availability.js.map